<template>
    <div class="mb-8" v-if="availableColorVariants && availableColorVariants?.length > 1">
        <div class="flex flex-wrap gap-1 lg:gap-2">
            <NuxtLink
                v-for="colorVariant in availableColorVariants"
                :key="colorVariant.id"
                :to="'/' + colorVariant.url"
                class="rounded-sm flex h-[125px] w-[100px] flex-col items-center justify-center border-[3px] border-green-400 bg-white transition duration-300 hover:border-green-600 hover:shadow-sm"
                :class="{ 'border-green-900!': colorVariant.is_selected }">
                <ShopwareImg
                    class="product-image h-[119px] w-[94px] object-cover"
                    :width="94"
                    :height="119"
                    :src="colorVariant.cover"
                    :alt="colorVariant.name"
                    :title="colorVariant.name" />
            </NuxtLink>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue';

    interface ColorVariant {
        id: string;
        name: string;
        cover: string;
        stock: null | number; // stock can be null in when api does not return the stock attribute, in later versions this is always present and can be converted to a not-nullable number.
        url: string;
        is_selected: boolean;
    }

    const props = defineProps<{ colorVariants?: ColorVariant[] }>();

    const availableColorVariants = computed(() => {
        return props.colorVariants?.filter(colorVariant => colorVariant.stock !== null && colorVariant.stock > 0) ?? [];
    });
</script>
